import React from "react";

const SeekApplyButton = ({ applyWithSeekButton }) => {
  if (!applyWithSeekButton) return null;

  const { buttonLabel, images, url } = applyWithSeekButton;

  return (
    <a
      href={url}
      ltarget="_blank"
      rel="noopener noreferrer"
      style={{ display: "inline-block" }}
    >
      <img
        src={images.light}
        alt={buttonLabel}
        aria-roledescription="link"
        style={{ height: "40px", cursor: "pointer" }}
      />
    </a>
  );
};

export default SeekApplyButton;
